export interface IApplicationConfiguration {
  id?: number;
  configurationName?: string;
  configurationValue?: string;
}

export const defaultValue: Readonly<IApplicationConfiguration> = {};
